/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import GalleryImageEditor from 'DesignSystem/GalleryImageEditor/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageViewer/PatientImages/Preview/Content"
  
}) {
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
let viewerIsToolbarHiddenValueData = fromData.useDataValue({ viewPath,
context: 'viewer',
path: 'is_toolbar_hidden',
})
  return (<React.Fragment
>
<GalleryImageEditor
  viewPath={`${viewPath}/GalleryImageEditor`}
 data="resource.preview_url"
 src={resourcePreviewUrlValueData}
 data="viewer.is_toolbar_hidden"
 isToolbarHidden={viewerIsToolbarHiddenValueData}
/>
{children}
</React.Fragment>)
}